import Button from "@pathwright/ui/src/components/button/Button"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Text from "@pathwright/ui/src/components/ui/Text"
import styled from "styled-components"

const StyledEmptyContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 7rem 1.5rem;
`

const StyledCalloutBox = styled(Text.Body)`
  margin-bottom: 1.3rem;
  padding: 1rem;
  background: whitesmoke;
  border-radius: 5px;
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;

  .Pathicon {
    margin-bottom: 0.3rem;
  }
`

const EmptyContent = () => (
  <StyledEmptyContent>
    <Text.H2 style={{ marginBottom: "1.3rem" }}>
      There's no content in this step yet.
    </Text.H2>
    <StyledCalloutBox>
      <Pathicon icon="lightbulb" /> Are you a designer and not sure how to work
      with Blocks?
    </StyledCalloutBox>
    <Text.Body style={{ textAlign: "center" }}>
      <Button
        brand
        target="_blank"
        href="https://help.pathwright.com/en/?q=blocks"
      >
        Get Help
      </Button>
    </Text.Body>
  </StyledEmptyContent>
)

export default EmptyContent
